import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconUploadOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" fillRule="nonzero" d="m12.75 7.81 3.923 3.923a.749.749 0 1 0 1.06-1.06L12 4.938l-5.733 5.733a.75.75 0 1 0 1.06 1.061l3.923-3.922V16.5H1.5v-15h21v15h-9.75zM11.25 18v6h1.5v-6H24V1.5A1.5 1.5 0 0 0 22.5 0h-21A1.5 1.5 0 0 0 0 1.5V18z" /></svg>
);
